import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

//Healthscale img
import healthscale_grey from '../../Images/Healthform/health_grey.png';
import healthscale_green from '../../Images/Healthform/health_green.png';
import healthscale_orange from '../../Images/Healthform/health_orange.png';
import healthscale_red from '../../Images/Healthform/health_red.png';

class EQ5DResDisplay extends Component {

    //Function to display form res alert logo with the good color
    getFormResImg(){
        if(this.props.formresDisplay.color === "#21BA45"){
            //return green
            return (<img src={healthscale_green} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="healthscale_logo"/>)
        }
        else if(this.props.formresDisplay.color === "#F2711C"){
            //return orange
            return (<img src={healthscale_orange} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="healthscale_logo"/>)
        }
        else if(this.props.formresDisplay.color === "#DB2828"){
            //return orange
            return (<img src={healthscale_red} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="healthscale_logo"/>)
        }
        else{
            //return grey
            return (<img src={healthscale_grey} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="healthscale_logo"/>)
        }
    }

    display_value(){


        let unit = ""
        if (this.props.formresDisplay.res !== "-") {
            unit = "/1"
        }        

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getFormResImg()
                }
                <Row>                    
                    <div style={{color: this.props.formresDisplay.color}}>
                        <span id="row-measure-style">{this.props.formresDisplay.res}</span>
                        <span id="row-unit-style">{unit}</span>                        
                    </div>                    
                </Row>
            </Row>
        )
    }    

    //Display render
    render(){

        return (
            <div>
                {(this.props.alert) ?
                    <Col style={{backgroundColor: "yellow"}}>
                        {this.display_value()}
                    </Col>
                    :
                    <Col>
                        {this.display_value()}
                    </Col>
                }
            </div>
        );
    }
}
export default (EQ5DResDisplay);